module.exports = __webpack_public_path__ + "static/media/process-storage-01.42a29bd1.svg";